import React, { useState } from "react"
import tw, { styled } from "twin.macro"
import { ChevronDown as ChevronDownIcon } from "react-feather"
//
import { Container, ContentWithPaddingXl } from "../misc/Layouts"
import { SectionHeading, Subheading as SubheadingBase } from "../misc/Headings"
import { SectionDescription } from "../misc/Typography"

const PrimaryBackgroundContainer = tw(Container)`-mx-8 px-8 bg-primary-900 text-gray-100`

const HeadingContainer = tw.div``
const Subheading = tw(SubheadingBase)`text-center text-gray-100 mb-4`
const Heading = tw(SectionHeading)``
const Description = tw(SectionDescription)`mx-auto text-center text-gray-300`

const FaqsContainer = tw.div`mt-10 sm:mt-16 w-full flex-1 lg:flex justify-between items-start max-w-screen-lg mx-auto`
const FaqsColumn = tw.div`w-full lg:max-w-lg lg:mr-12 last:mr-0`
const Faq = tw.div`select-none cursor-pointer border-b-2 border-primary-300 hover:border-primary-500 transition-colors duration-300 py-6`
const Question = tw.div`flex justify-between items-center`
const QuestionText = tw.div`text-sm sm:text-lg font-semibold tracking-wide`
const QuestionToggleIcon = styled.span`
  ${tw`ml-2 transition duration-300`}
  svg {
    ${tw`w-6 h-6`}
  }
`
const Answer = tw.div`hidden text-sm font-normal mt-4 text-gray-300`

export const TwoColumn = ({
  subheading = "",
  heading = "Frequently Asked Questions",
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  faqs = [
    {
      question: "Is lunch provided free of cost ?",
      answer:
        "Yes, it is, if you have a membership with us. Otherwise it is charged as per the menu. Some limits do apply as to how much items can be included in your lunch. This limit is enough for any one person and merely exists to discourage abusal of the system."
    },
    {
      question: "Do you have 2 Bedroom suites ?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    },
    {
      question: "Are Wi-Fi costs included in the price ?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    },
    {
      question: "Where can I reach you for support ?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    },
    {
      question: "What kind of SLA Guarantee do you provide ? ",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    },
    {
      question: "Where are the servers located ?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    }
  ]
}) => {
  const faqCol1 = []
  const faqCol2 = []
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null)

  const toggleQuestion = (questionIndex) => {
    if (activeQuestionIndex === questionIndex) {
      setActiveQuestionIndex(null)
    } else {
      setActiveQuestionIndex(questionIndex)
    }
  }

  faqs.map((faq, index) => {
    const renderedFaq = (
      <Faq key={index} onClick={() => toggleQuestion(index)}>
        <Question>
          <QuestionText>{faq.question}</QuestionText>
          <QuestionToggleIcon
            variants={{
              collapsed: { rotate: 0 },
              open: { rotate: -180 }
            }}
            initial="collapsed"
          >
            <ChevronDownIcon />
          </QuestionToggleIcon>
        </Question>
        {activeQuestionIndex === index ? (
          <Answer
            variants={{
              open: {
                opacity: 1,
                height: "auto",
                marginTop: "16px",
                display: "block"
              },
              collapsed: {
                opacity: 0,
                height: 0,
                marginTop: "0px",
                display: "none"
              }
            }}
            initial="collapsed"
          >
            {faq.answer}
          </Answer>
        ) : null}
      </Faq>
    )

    if (index % 2 === 0) {
      faqCol1.push(renderedFaq)
    } else {
      faqCol2.push(renderedFaq)
    }

    return null
  })
  return (
    <PrimaryBackgroundContainer>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          <Description>{description}</Description>
        </HeadingContainer>
        <FaqsContainer>
          <FaqsColumn>{faqCol1}</FaqsColumn>
          <FaqsColumn>{faqCol2}</FaqsColumn>
        </FaqsContainer>
      </ContentWithPaddingXl>
    </PrimaryBackgroundContainer>
  )
}

export default TwoColumn
